import axios from "axios";
import { concernsCurrentSession } from "./authTransport";
import { installRequestLoader } from "./requestLoader";
import { configuredBackendBase } from "./backendUrl";

const BACKEND_URL = configuredBackendBase();
export const MASTER_API = `${BACKEND_URL}/api/master`;

const masterApi = axios.create({ baseURL: MASTER_API });

masterApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("bd_master_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

masterApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && concernsCurrentSession(err, "bd_master_token") && !window.location.pathname.includes("/master/login")) {
      localStorage.removeItem("bd_master_token");
      window.location.href = "/master/login";
    }
    return Promise.reject(err);
  }
);

installRequestLoader(masterApi);
export default masterApi;
